var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"9 18 15 12 9 6"}));
}

ChevronRightInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-right"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
